import { firebaseApp } from './../firebase';
import { getFirestore, collection, getDocs, query, where } from "firebase/firestore";

// Action types
export const LOAD_ANALYTICS_DATA_START = 'LOAD_ANALYTICS_DATA_START';
export const LOAD_ANALYTICS_DATA_SUCCESS = 'LOAD_ANALYTICS_DATA_SUCCESS';
export const LOAD_ANALYTICS_DATA_ERROR = 'LOAD_ANALYTICS_DATA_ERROR';

// Load analytics data actions
export const loadAnalyticsDataStart = () => {
    return { type: LOAD_ANALYTICS_DATA_START };
};

export const loadAnalyticsDataSuccess = (data) => {
    return { type: LOAD_ANALYTICS_DATA_SUCCESS, payload: data };
};

export const loadAnalyticsDataError = (errorMessage) => {
    return { type: LOAD_ANALYTICS_DATA_ERROR, payload: errorMessage };
};

export const loadAnalyticsData = (userId, handle) => {
    return async(dispatch) => {
        dispatch(loadAnalyticsDataStart());

        if (!userId || !handle) {
            dispatch(loadAnalyticsDataSuccess({ growth: [], botActivity: [] }));
            return;
        }

        try {
            const firestore = getFirestore(firebaseApp);
            
            // Load growth data
            const growthQuerySnapshot = await getDocs(
                query(
                    collection(firestore, "dailyGrowthStat"), 
                    where("populated", "==", true), 
                    where("userId", "==", userId), 
                    where("handle", "==", handle)
                )
            );
            const growth = growthQuerySnapshot.docs.map((doc) => doc.data());

            // Load bot activity data
            const botActivityQuerySnapshot = await getDocs(
                query(
                    collection(firestore, "botExecutionLogs"),
                    where("userId", "==", userId),
                    where("handle", "==", handle)
                )
            );
            const botActivity = botActivityQuerySnapshot.docs.map((doc) => doc.data());

            dispatch(loadAnalyticsDataSuccess({ growth, botActivity }));
        } catch (error) {
            dispatch(loadAnalyticsDataError(error.message));
        }
    };
};

